import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './api';

export interface RewardResponse {
  id: string;
  activityType: string;
  amount: number;
  status: string;
  prospectId?: string;
  prospectName?: string;
  prospectCompany?: string;
  testimonialId?: string;
  detailsEn?: string;
  description?: string;
  paymentId?: string;
  paymentDate?: string;
  paymentMethod?: string;
  createdAt: string;
  updatedAt: string;
  isSpecificReward: boolean;
  bonusMessage?: string;
  currency: string;
}

export interface RewardPage {
  content: RewardResponse[];
  totalElements: number;
  totalPages: number;
  size: number;
  number: number;
}

export const rewardApi = createApi({
  reducerPath: 'rewardApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Reward'],
  endpoints: (builder) => ({
    getPromoterRewards: builder.query<RewardPage, { promoterId: string; page?: number; size?: number }>({
      query: ({ promoterId, page = 0, size = 20 }) => 
        `/vendors/me/promoters/${promoterId}/rewards?page=${page}&size=${size}`,
      providesTags: (result, error, { promoterId }) => [{ type: 'Reward', id: promoterId }],
    }),
  }),
});

export const { useGetPromoterRewardsQuery } = rewardApi;
